import * as React from 'react';
import { Column, Stack, Heading } from '@locus-taxy/neo-ui';
import { translate } from 'react-i18next';

const LoginLeftSection = props => {
    const { t } = props;
    return (
        <Column>
            <Stack space="small">
                <Heading fontSize="36px" level="1">
                    {t('pageDescription')}
                </Heading>
            </Stack>
        </Column>
    );
};

export default translate('settings')(LoginLeftSection);
